
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_12nke_97",
  "fit-height": "awsui_fit-height_14iqq_12nke_133",
  "with-side-media": "awsui_with-side-media_14iqq_12nke_138",
  "variant-default": "awsui_variant-default_14iqq_12nke_141",
  "variant-stacked": "awsui_variant-stacked_14iqq_12nke_141",
  "refresh": "awsui_refresh_14iqq_12nke_149",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_12nke_199",
  "with-top-media": "awsui_with-top-media_14iqq_12nke_211",
  "content-wrapper": "awsui_content-wrapper_14iqq_12nke_216",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_12nke_221",
  "media": "awsui_media_14iqq_12nke_226",
  "media-top": "awsui_media-top_14iqq_12nke_244",
  "media-side": "awsui_media-side_14iqq_12nke_249",
  "header": "awsui_header_14iqq_12nke_255",
  "header-with-media": "awsui_header-with-media_14iqq_12nke_260",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_12nke_266",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_12nke_270",
  "header-stuck": "awsui_header-stuck_14iqq_12nke_276",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_12nke_286",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_12nke_289",
  "with-paddings": "awsui_with-paddings_14iqq_12nke_295",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_12nke_304",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_12nke_362",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_14iqq_12nke_382",
  "dark-header": "awsui_dark-header_14iqq_12nke_391",
  "content": "awsui_content_14iqq_12nke_216",
  "content-fit-height": "awsui_content-fit-height_14iqq_12nke_399",
  "content-with-media": "awsui_content-with-media_14iqq_12nke_409",
  "footer": "awsui_footer_14iqq_12nke_413",
  "with-divider": "awsui_with-divider_14iqq_12nke_417"
};
  